import React  from 'react';
import { ReferenceArrayField, SingleFieldList, ChipField, TextField, CloneButton } from "react-admin";
import { ListGuesser } from "@api-platform/admin";

const CloneElement = ({ record }) => {
  const omitId = ({ id, originId, uuid, ...rest }) => rest;
  delete record["@type"];
  delete record["@id"];

  return (<CloneButton to={{
          pathname: `step_formats/create`,
          state: { record: omitId(record) }
        }}/>);
};

const StepFormatList = (props) => (
    <ListGuesser {...props}>
      <TextField source="name" />
      <TextField source="title" />
      <TextField source="description" />
      <ReferenceArrayField
        label="Images"
        reference="files"
        source="images"
      >
        <SingleFieldList>
            <ChipField source="title" />
        </SingleFieldList>
      </ReferenceArrayField>
      <CloneElement />
    </ListGuesser>
);

export default StepFormatList;